// extracted by mini-css-extract-plugin
export default {"confirmation":"Confirmation_confirmation__6Ph4f","check":"Confirmation_check__c7s3-","thanks":"Confirmation_thanks__1isva","msg":"Confirmation_msg__yaUJm"};